import altoCustoGerenciamentoProcesso from './altoCustoGerenciamentoProcessoRepository'
import chamadaRepository from './chamadaRepository'
import dispensacao from './dispensacaoRepository'
import estornoDispensacao from './estornoDispensacaoRepository'
import filaAtendimentoRepository from './filaAtendimentoRepository'
import livroPsicotropico from './livroPsicotropicoRepository'
import livroTalidomida from './livroTalidomidaRepository'
import medicamentoNaoPadronizado from './medicamentoNaoPadronizadoRepository'
import parametrizacao from './parametrizacaoRepository'
import relatorioAltoCustoDispensacao from './relatorioAltoCustoDispensacaoRepository'
import relatorioAltoCustoEstatisticoCid from './relatorioAltoCustoEstatisticoCidRepository'
import relatorioAltoCustoProcesso from './relatorioAltoCustoProcessoRepository'
import relatorioAltoCustoProcessoPaciente from './relatorioAltoCustoProcessoPacienteRepository'
import relatorioAltoCustoRetiradaPendente from './relatorioAltoCustoRetiradaPendenteRepository'
import relatorioAtendimentoDiario from './relatorioAtendimentoDiarioRepository'
import relatorioDispensacao from './relatorioDispensacaoRepository'
import relatorioDispensacaoPaciente from './relatorioDispensacaoPacienteRepository'
import relatorioDispensacaoRemedioCasa from './relatorioDispensacaoRemedioCasaRepository'
import relatorioEstornoDispensacao from './relatorioEstornoDispensacaoRepository'
import relatorioMovimentacaoPsicotropico from './relatorioMovimentacaoPsicotropicoRepository'
import relatorioPacienteAtendido from './relatorioPacienteAtendidoRepository'
import relatorioQuantitativoDispensacao from './relatorioQuantitativoDispensacaoRepository'
import supervisor from './supervisorRepository'

export default baseUrl => {
    baseUrl = `${baseUrl}/farmacia`

    return {
        altoCustoGerenciamentoProcesso: altoCustoGerenciamentoProcesso(baseUrl),
        chamada: chamadaRepository(baseUrl),
        dispensacao: dispensacao(baseUrl),
        estornoDispensacao: estornoDispensacao(baseUrl),
        filaAtendimento: filaAtendimentoRepository(baseUrl),
        livroPsicotropico: livroPsicotropico(baseUrl),
        livroTalidomida: livroTalidomida(baseUrl),
        medicamentoNaoPadronizado: medicamentoNaoPadronizado(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        relatorioAltoCustoDispensacao: relatorioAltoCustoDispensacao(baseUrl),
        relatorioAltoCustoEstatisticoCid: relatorioAltoCustoEstatisticoCid(baseUrl),
        relatorioAltoCustoProcesso: relatorioAltoCustoProcesso(baseUrl),
        relatorioAltoCustoProcessoPaciente: relatorioAltoCustoProcessoPaciente(baseUrl),
        relatorioAltoCustoRetiradaPendente: relatorioAltoCustoRetiradaPendente(baseUrl),
        relatorioAtendimentoDiario: relatorioAtendimentoDiario(baseUrl),
        relatorioDispensacao: relatorioDispensacao(baseUrl),
        relatorioDispensacaoPaciente: relatorioDispensacaoPaciente(baseUrl),
        relatorioDispensacaoRemedioCasa: relatorioDispensacaoRemedioCasa(baseUrl),
        relatorioEstornoDispensacao: relatorioEstornoDispensacao(baseUrl),
        relatorioMovimentacaoPsicotropico: relatorioMovimentacaoPsicotropico(baseUrl),
        relatorioPacienteAtendido: relatorioPacienteAtendido(baseUrl),
        relatorioQuantitativoDispensacao: relatorioQuantitativoDispensacao(baseUrl),
        supervisor: supervisor(baseUrl),
    }
}